import { T } from '../../../../../../../Translations';

export type TabType = 'programs' | 'schoolPartners' | 'competencies';
type TabLabel = 'Programs' | 'School Partners' | 'Competencies';

interface TabMetadata {
  programsCount: number;
  schoolPartnersCount: number;
  competenciesCount: number;
}

interface Props {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  metadata: TabMetadata;
}

const TabNavigation: React.FC<Props> = ({ activeTab, onTabChange, metadata }) => {
  const tabs: { key: TabType; label: TabLabel; count: number; intercomTarget: string }[] = [
    {
      key: 'programs',
      label: 'Programs',
      count: metadata.programsCount,
      intercomTarget: 'curated-section-programs-tab',
    },
    {
      key: 'schoolPartners',
      label: 'School Partners',
      count: metadata.schoolPartnersCount,
      intercomTarget: 'curated-section-school-partners-tab',
    },
    {
      key: 'competencies',
      label: 'Competencies',
      count: metadata.competenciesCount,
      intercomTarget: 'curated-section-competencies-tab',
    },
  ];

  return (
    <div className="border-b border-border">
      <div className="flex gap-8">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            className={`pb-3 px-2 border-b-2 transition-colors ${
              activeTab === tab.key
                ? 'border-primary text-primary'
                : 'border-transparent text-muted-foreground hover:text-foreground'
            }`}
            data-intercom-target={tab.intercomTarget}
          >
            <span className="flex items-center gap-2">
              <T kind={tab.label} />
              <span
                className={`inline-flex items-center justify-center min-w-[24px] h-6 px-2 rounded-full text-sm font-medium ${
                  activeTab === tab.key
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-foreground'
                }`}
              >
                {tab.count}
              </span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabNavigation;
